import { Form } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import Empty from "../common/Empty";
import moment from "moment";
import TopHeader from "./Layout/topHeader";
import ShopLayout from "./Layout";
import { responseNotification } from "../../utils/notify";

const MerchantTransactionList = () => {
  const [limit, setLimit] = useState(16);
  const [transactionsData, setTransactionsData] = useState({
    loading: false,
    data: null,
  });

  const route = useParams();

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const fetchTransactions = useCallback((getShopId) => {
    if (getShopId) {
      try {
        setTransactionsData({ loading: true, data: undefined });
        axios
          .get(
            `${process.env.REACT_APP_RIDER_API}/admin/merchant/transaction-history?shopId=${getShopId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              setTransactionsData({
                loading: false,
                data: data?.data,
              });
            } else {
              setTransactionsData({ loading: false, data: null });
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            setTransactionsData({ loading: false, data: null });

            console.log(err);
          });
      } catch (error) {
        setTransactionsData({ loading: false, data: null });

        console.log(error, "error");
      }
    }
  }, []);

  useEffect(() => {
    fetchTransactions((route as any)?.shopId);
  }, [fetchTransactions]);

  return (
    <React.Fragment>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="bg-white">
          <TopHeader leftarea={"Transaction History"} rightarea={""} />

          <div className="product-list-item-area white-bg section-padding-bottom">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="product-list-items-inner-content">
                    <div className="single-product-wrapper">
                      <div className="single-product-heading">
                        <span>Date & Time</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Transaction ID</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Type</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Order ID</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Description</span>
                      </div>
                      <div className="single-product-heading">
                        <span>Amount</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                {transactionsData?.loading ? (
                  <Loading />
                ) : (
                  <div className="col-lg-12 product-table">
                    <div className="product-table-area">
                      {transactionsData?.data?.transactions?.length ? (
                        transactionsData?.data?.transactions?.map(
                          (transaction, index) => (
                            <React.Fragment key={index}>
                              <div className="single-product-wrapper">
                                <div className="single-product">
                                  <span className="name text-nowrap text-capitalize">
                                    {moment(transaction?.createdAt).format(
                                      "lll"
                                    )}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">
                                    {transaction?.transactionId}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">
                                    {transaction?.type?.replace("-", " ")}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">
                                    {transaction?.orderId}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">
                                    {transaction?.description?.substr(0, 45)}
                                  </span>
                                </div>
                                <div className="single-product">
                                  <span className="name">
                                    &#2547;{transaction?.amount}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          )
                        )
                      ) : (
                        <Empty data="Transactions" />
                      )}
                    </div>
                  </div>
                )}
              </div>

              <PaginationTwo
                {...transactionsData?.data}
                limit={limit}
                page={getPage(loc.search)}
              />
            </div>
          </div>
        </div>
      </ShopLayout>
    </React.Fragment>
  );
};

export default MerchantTransactionList;
